import React from "react"

export const UsersIcon = ({ size = 25 }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox='0 0 25 25'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M21.911 17.153 20.5 16.55v-1.906a5.2 5.2 0 0 0 1.75-3.893V6.83A4.836 4.836 0 0 0 17.419 2h-.838a4.837 4.837 0 0 0-4.831 4.83v3.92a5.2 5.2 0 0 0 1.75 3.893v1.906l-1.41.604A3.44 3.44 0 0 0 10 20.321v1.804c0 .483.392.875.875.875h12.25a.875.875 0 0 0 .875-.875V20.32c0-1.381-.82-2.624-2.089-3.168'
        fill='currentColor'
      />
      <path
        d='m11.4 15.544.35-.15v-.034A6.98 6.98 0 0 1 10 10.75V6.83c0-1.096.273-2.128.749-3.038-.157-.016-.318-.042-.468-.042h-.838c-2.807 0-4.693 2.725-4.693 5.27v2.624c0 1.5.633 2.896 1.75 3.894v1.01l-1.41.604A3.44 3.44 0 0 0 3 20.321v1.804c0 .483.392.875.875.875h4.536a2.6 2.6 0 0 1-.161-.875V20.32a5.19 5.19 0 0 1 3.15-4.777'
        fill='currentColor'
      />
    </svg>
  )
}
